// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tw6B","index":"styles_index__1pkEz"};